export const API_DOMAIN =
  process.env.GATSBY_API_DOMAIN || "http://localhost:3000";
